import EntityService from '@/services/EntityService'
import { Labor } from '@/models/labor'

export default class LaborService extends EntityService<Labor> {
  constructor() {
    super({ collectionName: 'labor' })
  }
}